import React from 'react';
import { Box, Typography } from '@mui/material';
import { processLatexString } from '../LatexRenderer';
import SectionWrapper from './SectionWrapper';

const QuestionPreview = ({ 
  templated, 
  edited, 
  documentId, 
  imageMap = {} 
}) => {
  if (!templated) return null;

  const renderExtendedWithParts = () => (
    <Box>
      <Typography variant="body1" gutterBottom>
        {processLatexString(edited.question_content || templated.question_content, parseInt(documentId), imageMap)}
      </Typography>
      {templated.parts.map((part) => (
        <Box key={part.id} sx={{ mt: 1 }}>
          <Typography variant="body2" color="primary">
            Part {part.part_number}:
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            {processLatexString(edited[`part_${part.id}_content`] || part.part_content, parseInt(documentId), imageMap)}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const renderContent = () => {
    if (templated.type === 'mcq') {
      // For MCQ, only show the question content, not the options
      return (
        <Typography variant="body1" gutterBottom>
          {processLatexString(edited.question_content || templated.question_content, parseInt(documentId), imageMap)}
        </Typography>
      );
    }

    if (templated.has_parts && templated.parts && templated.parts.length > 0) {
      return renderExtendedWithParts();
    }

    return (
      <Typography variant="body1">
        {processLatexString(edited.question_content || templated.question_content, parseInt(documentId), imageMap)}
      </Typography>
    );
  };

  return (
    <SectionWrapper title="Question Preview">
      <Box sx={{ overflow: 'auto', maxWidth: '100%', flex: 1 }}>
        {renderContent()}
      </Box>
    </SectionWrapper>
  );
};

export default QuestionPreview;